/**
 * @file 工具函数类
 *
 * @author yujinjiang@baidu.com
 */

import superAgent from 'superagent';
import Const from '../constant/Constant';
/* global wx */
import {jsonp, getPlatInfo, requestBdApi, getNativeInfo, getParamsFromUrl, genUUID} from '@baidu/map-fe-utils';
/**
 * 判断是否是微信
 *
 * @return {boolean}
 */
export const isWeiXin = () => navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
export const isAndroid = () => navigator.userAgent.toLowerCase().indexOf('android') > -1;
// 组件化安卓判断
export const isAndroidCom = () => navigator.userAgent.toLowerCase().indexOf('baidumap_andr') > -1;
export const isBaiduApp = () => navigator.userAgent.toLowerCase().indexOf('baiduboxapp') > -1;
export const isIos = () => getPlatInfo().isIos;
export const isHarmony = () => navigator.userAgent.toLowerCase().indexOf('arkweb') > -1;

// 向url追加参数
export const appendParamToUrl = (url, param) => {
    let appendedUrl;
    if (url.indexOf('?') >= 0) {
        // 有参数
        appendedUrl = `${url}&${param}`;
    }
    else {
        appendedUrl = `${url}?${param}`;
    }

    return appendedUrl;
};

/**
 * 初始化微信分享
 *
 * @param {Object} config 初始化参数
 * @param {Object} shareOption 需要分享的参数
 */

export const initWXShare = (config = {}, shareOption = {}) => {
    if (!wx) {
        return;
    }

    let shareUrl = shareOption.link || location.href;
    const urlParams = getUrlParams(location.href);
    if (!urlParams.ncpshare) {
        shareUrl = appendParamToUrl(shareUrl, 'ncpshare=wechat');
    }

    wx.config(config);

    const baseShareConfig = {
        title: shareOption.title || document.title, // 分享标题,
        link: shareUrl,
        imgUrl:
            shareOption.imgUrl || 'https://lbsugc.cdn.bcebos.com/images/B5ee9901e3cabd18341.png'
    };

    wx.ready(() => {
        // console.log('ready');
        // 初始化微信打开二次分享到朋友圈
        wx.updateTimelineShareData(baseShareConfig);
        // 初始化微信打开分享给好友
        wx.updateAppMessageShareData({
            ...baseShareConfig,
            desc: shareOption.desc
        });
    });

    wx.error(e => {
        console.log(e, 'error');
    });
};

/**
 * h5分享面板升级，根据分享配置生成分享数据
 *
 * @param {Object} shareConfig - 分享配置
 * @returns {Object} - 分享数据
 */
export function makeShareData(shareConfig = {}) {
    const {title, text, wxFriend, wxPic, weiboPic, weiboText, url, from} = shareConfig || {};
    const SHARE_DATA = [
        {
            src: 'weixin',
            title,
            text,
            url,
            contentType: 'text',
            pic: wxPic, // 微信分享图片尺寸有要求，需单独设置
            from
        },
        {
            src: 'friend',
            text: wxFriend,
            url,
            contentType: 'text',
            pic: wxPic, // 微信分享图片尺寸有要求，需单独设置
            from
        },
        {
            src: 'weibo',
            text: weiboText,
            url,
            pic: weiboPic,
            from
        },
        {
            src: 'more',
            url,
            title,
            text,
            from
        },
        {
            src: 'copy_link',
            url, // 必传参数
            from
        },
        {
            src: 'scan_share', // 扫码分享
            title, // 兼容安卓分享不报错
            text,
            url,
            contentType: 'text',
            pic: wxPic,
            from,
            scanShareUrl:
                'https://map.baidu.com/zt/webapp/currency/scan.html?qrcodeUrl=https%3A%2F%2Fmap.baidu.com%2Fzt%2Fy2022%2FtombSweeping%2Findex.html',
            transparentWeb: '1',
            hiddenBackBtn: '1',
            hiddenTitle: '1'
        }
    ];
    return SHARE_DATA;
}
/**
 * json字符串转成对象
 * @param {string} jsonStr
 * @returns
 */
export const parseJson = jsonStr => {
    try {
        if (typeof jsonStr === 'object') {
            return jsonStr;
        }
        if (typeof jsonStr !== 'string') {
            return {};
        }
        return JSON.parse(jsonStr) || {}; // 返回解析结果，如果解析失败则返回空对象
    }
    catch (err) {
        console.error('JSON解析失败:', err.message); // 输出错误信息
        return {}; // 返回空对象作为默认值
    }
};

// 获取url参数
export function getUrlParams(url) {
    // 获取URL中?之后的字符
    const strArr = url.split('?');
    if (strArr.length < 2) {
        return {};
    }
    // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
    const arr = strArr[1].split('&');
    let obj = {};

    // 将每一个数组元素以=分隔并赋给obj对象
    for (let i = 0; i < arr.length; i++) {
        let temArr = arr[i].split('=');
        const index = arr[i].indexOf('=') + 1;
        obj[decodeURIComponent(temArr[0])] = decodeURIComponent(arr[i].slice(index));
    }

    const {container = ''} = obj;
    // container === 'lgui' 时，使用lgui容器传过来的url参数
    if (container === 'lgui') {
        let {sv = '', abtest = '', params = {}, phoneinfo = {}} = obj;
        const {sv: phoneSv, abtest: phoneAbtest} = parseJson(phoneinfo) || {};
        let lcontainerParams = parseJson(params) || {};
        let {pageParam = {}} = lcontainerParams;
        if (typeof pageParam === 'string') {
            pageParam = parseJson(pageParam);
        }
        if (pageParam.preloadInfo) {
            pageParam.preloadInfo = decodeURIComponent(pageParam.preloadInfo);
        }
        obj = {...obj, ...pageParam};
        obj.sv = phoneSv || sv;
        obj.abtest = phoneAbtest || abtest;
    }

    return obj;
}


/**
 * 从客户端外调起客户端(为不影响原有逻辑，榜单单独封装)
 *
 * @param {string} openapi 需要跳转的openapi页面，openapi优先级高于url
 * @param {string} url 需要跳转的h5页面
 */
export function openMap(params) {
    let {url, src = '', from = '', token = '', openapi = ''} = params;
    // 地图外跳转到地图内
    openapi
        = openapi
        || `baidumap://map/cost_share?url=${encodeURIComponent(url)}&needLocation=yes&src=${src}`;
    checkOpen(res => {
        if (!res) {
            location.href = openMapLink(openapi, from, token);
        }
    });
}

// 手百调起客户端(屏蔽提示弹窗)
export function openMapIsBD(params) {
    let {url, src = '', openapi = '', webUrl = '', payload = {}} = params;
    const obj = {
        appUrl:
            openapi
            || `baidumap://map/cost_share?url=${encodeURIComponent(url)}&needLocation=yes&src=${src}`,
        webUrl:
            webUrl
            || 'https://map.baidu.com/mapclient-pages/download/index.html?from=bangdan&token=WEBAPP9001',
        ...payload
    };
    const deeplink
        = 'baiduboxapp://v7/vendor/ad/deeplink?params=' + encodeURIComponent(JSON.stringify(obj));
    window.location.href = deeplink;
}

// 接口获取是否有跳转提示弹窗
export function getCloudControl(from, callback) {
    let api_url = 'https://ugc.map.baidu.com/cube/util/cloudcontrol';
    // 目前为必传项，后端说是以后做拓展用的字段，目前让写死一个值
    let params = {
        from
    };
    jsonp(api_url, params).then(_ => {
        callback();
    });
}

// 检查app是否打开
export function checkOpen(cb) {
    let _clickTime = +new Date();
    function check(elsTime) {
        if (document.hidden || document.webkitHidden) {
            cb(1);
        }
        else {
            cb(0);
        }
    }
    // 启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
    let _count = 0;
    let intHandle = setInterval(() => {
        _count++;
        let elsTime = +new Date() - _clickTime;
        if (_count >= 100 || elsTime > 3000) {
            clearInterval(intHandle);
            check(elsTime);
        }
    }, 20);
}

export function openMapLink(openapi, from, token) {
    return `https://map.baidu.com/mapclient-pages/download/index.html?from=${from}&token=${token}&openapi=${encodeURIComponent(
        openapi
    )}`;
}

// 是否在地图中
export function isBaiduMap() {
    const ua = window.navigator.userAgent.toLowerCase();
    return /baidumap_/i.test(ua);
}

// 是否在车机地图中
export function isBaiduMapAuto() {
    const ua = window.navigator.userAgent.toLowerCase();
    return /baidumapauto_/i.test(ua);
}

// iphone
export function isIPhone() {
    return /iphone/i.test(navigator.userAgent);
}

// 墨卡托转经纬度
export function mercatorlonLat(merX, merY) {
    let band = [12890594.86, 8362377.87, 5591021, 3481989.83, 1678043.12, 0];
    // 多项式系数
    let MC2LL = [
        [
            1.410526172116255e-8,
            0.00000898305509648872,
            -1.9939833816331,
            200.9824383106796,
            -187.2403703815547,
            91.6087516669843,
            -23.38765649603339,
            2.57121317296198,
            -0.03801003308653,
            17337981.2
        ],
        [
            -7.435856389565537e-9,
            0.000008983055097726239,
            -0.78625201886289,
            96.32687599759846,
            -1.85204757529826,
            -59.36935905485877,
            47.40033549296737,
            -16.50741931063887,
            2.28786674699375,
            10260144.86
        ],
        [
            -3.030883460898826e-8,
            0.00000898305509983578,
            0.30071316287616,
            59.74293618442277,
            7.357984074871,
            -25.38371002664745,
            13.45380521110908,
            -3.29883767235584,
            0.32710905363475,
            6856817.37
        ],
        [
            -1.981981304930552e-8,
            0.000008983055099779535,
            0.03278182852591,
            40.31678527705744,
            0.65659298677277,
            -4.44255534477492,
            0.85341911805263,
            0.12923347998204,
            -0.04625736007561,
            4482777.06
        ],
        [
            3.09191371068437e-9,
            0.000008983055096812155,
            0.00006995724062,
            23.10934304144901,
            -0.00023663490511,
            -0.6321817810242,
            -0.00663494467273,
            0.03430082397953,
            -0.00466043876332,
            2555164.4
        ],
        [
            2.890871144776878e-9,
            0.000008983055095805407,
            -3.068298e-8,
            7.47137025468032,
            -0.00000353937994,
            -0.02145144861037,
            -0.00001234426596,
            0.00010322952773,
            -0.00000323890364,
            826088.5
        ]
    ];
    let params;
    for (let i = 0; i < band.length; i++) {
        if (Math.abs(merY) >= band[i]) {
            params = MC2LL[i];
            break;
        }
    }
    let lng = params[0] + params[1] * Math.abs(merX);
    let lat = Math.abs(merY) / params[9];
    lat
        = params[2]
        + params[3] * lat
        + params[4] * Math.pow(lat, 2)
        + params[5] * Math.pow(lat, 3)
        + params[6] * Math.pow(lat, 4)
        + params[7] * Math.pow(lat, 5)
        + params[8] * Math.pow(lat, 6);
    lng *= merX < 0 ? -1 : 1;
    lat *= merY < 0 ? -1 : 1;
    // 输出 '经度,纬度' 的格式，可调
    return {x: lng.toFixed(6), y: lat.toFixed(6)};
}

// 格式化事件
export function getTime(time) {
    if (!time) {
        return;
    }
    const d = new Date(time * 1000);
    let h = d.getHours();
    h = h > 9 ? h : `0${h}`;
    let m = d.getMinutes();
    m = m > 9 ? m : `0${m}`;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${h}:${m}`;
}

export function getClientWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth;
}

export function compressedBosImg(
    imgUrl,
    compressHiphotos = false,
    width = getClientWidth() * 2,
    quality = 70
) {
    if (imgUrl.indexOf('image/crop') === -1 && imgUrl.indexOf('bcebos.com') > 0) {
        return `${imgUrl}@w_${width},q_${quality}`;
    }

    if (/hiphotos/.test(imgUrl) && compressHiphotos) {
        return `https://webmap1.bdimg.com/client/services/thumbnails?sh=2&width=${width}&align=center&quality=60&src=${imgUrl}`;
    }

    return imgUrl;
}


/**
 * 客户端埋点(新)
 *
 * @param {Array} action 埋点信息
 * @param {Object} args 埋点参数
 */
let naInfoForBury = null;
export async function addPvNew(action = [], args = {}) {

    if (isBaiduMap() && !naInfoForBury) {
        const urlInfo =  getParamsFromUrl();

        // 如果url携带了设备信息信息，则使用url携带的设备信息
        if (urlInfo.os && urlInfo.sv && urlInfo.mb && urlInfo.cuid) {
            naInfoForBury = urlInfo;
        }
        else {
            naInfoForBury = await getNativeInfo();
        }
    }

    const {os, sv, is_preloader = 0, net, brand, mb, cuid, channel, screen, loc_x: locx, loc_y: locy, c}
        = naInfoForBury || {};
    const params = Object.assign(
        {},
        {
            os,
            sv,
            net,
            brand,
            mb,
            cuid,
            channel,
            screen,
            loc_x: locx,
            loc_y: locy,
            city_id: c,
            t: new Date().valueOf(),
            da_src: action.join('.'),
            is_preloader
        },
        args
    );
    const buryUrl
        = 'https://newclient.map.baidu.com/stats/transparent.gif?resid=01&' + parseParams(params);
    let image = new Image();
    image.src = buryUrl;
    image.onload = () => {
        image = null;
    };
    image.onerror = () => {
        image = null;
    };
}

/**
 * 客户端埋点-ulog
 * @param {Array} action 埋点信息
 * @param {Object} args 埋点参数
 */
export async function ulogBury(action = [], args = {}) {
    const params = Object.assign(
        {},
        args
    );
    requestBdApi(`bdapi://WebLogStat?type=online&act=${action}&${parseParams(params)}`);
}

/**
 * 客户端埋点 - 来自周边统计
 *
 * @param {Object} actionData 动态埋点信息
 */
export async function formNearbyAddPv(actionData = {}) {
    if (!isBaiduMap()) {
        return;
    }

    let urlParams = getUrlParams(location.href);

    if (urlParams.ebmfrom !== 'mapebmrec') {
        return;
    }

    // 过滤掉空参数
    urlParams = Object.keys(urlParams).reduce((all, item) => {
        if (item) {
            all[item] = urlParams[item];
        }

        return all;
    }, {});

    let naInfo = await getNativeInfo();

    const {os, sv, net, mb, cuid, channel, screen, loc_x: locx, loc_y: locy} = naInfo;

    const params = {
        ...urlParams,
        os,
        sv,
        map_version: sv,
        net,
        cuid,
        channel,
        screen,
        mb,
        loc: `${locx},${locy}`,
        t: new Date().valueOf(),
        qt: 'datainfo',
        event_type: 'card_click',
        content_type: 'bangdan',
        tab_name: urlParams.tab || '',
        source: urlParams.source || '',
        ...actionData
    };

    if (!window.formNearbyAddPvCallback) {
        window.formNearbyAddPvCallback = () => {};
    }

    const buryUrl = `https://newclient.map.baidu.com/client/cube/log/collector?callback=formNearbyAddPvCallback&${parseParams(
        params
    )}`;

    let script = document.createElement('script');
    script.src = buryUrl;
    script.onload = () => {
        script.remove();
    };
    script.onerror = () => {
        script.remove();
    };

    document.getElementsByTagName('head')[0].appendChild(script);
}

/**
 * 来自周边的时候，透传from
 *
 * @param {Object} urlParams 所有的url参数
 * @return {Object} 对象
 */
export function formNearbyAddFromParam(urlParams) {
    if (!urlParams) {
        urlParams = getUrlParams(location.href);
    }

    if (urlParams.ebmfrom !== 'mapebmrec') {
        return {};
    }

    const backData = {
        ebmfrom: urlParams.ebmfrom
    };

    if (urlParams.log_id) {
        backData.log_id = urlParams.log_id;
    }

    if (urlParams.uniq_id) {
        backData.uniq_id = urlParams.uniq_id;
    }

    if (urlParams.abtest) {
        backData.abtest = urlParams.abtest;
    }

    if (urlParams.tab) {
        backData.tab = urlParams.tab;
    }

    if (urlParams.source) {
        backData.source = urlParams.source;
    }

    return backData;
}

export function parseParams(object) {
    return Object.keys(object).reduce(
        (pre, next) => `${pre}${next}=${encodeURIComponent(object[next])}&`,
        ''
    );
}

export function isPhone6p() {
    const h = window.innerHeight;
    const w = window.innerWidth;
    const useragent = navigator.userAgent.toLowerCase();
    let isP6p = false;

    if (
        useragent.match(/mobile/i) !== null
        && useragent.match(/iphone/i) !== null
        && (h > w ? Math.abs(w - 414) < 10 && h <= 736 : Math.abs(w - 736) < 10 && h <= 414)
    ) {
        isP6p = true;
    }

    return isP6p;
}

export const coordinateTools = {
    /**
     * 根据平面直角坐标计算两点间距离;
     * @param {Object}} px1 坐标1
     * @param {Object}} px2 坐标2
     */
    getDistance(px1, px2) {
        let lon1 = (Math.PI / 180) * px1.y; // 开始经度
        let lon2 = (Math.PI / 180) * px2.y; // 结束经度
        let lat1 = (Math.PI / 180) * px1.x; // 开始纬度
        let lat2 = (Math.PI / 180) * px2.x; // 结束纬度
        // 地球半径
        let R = 6371;
        // 两点间距离 km，如果想要米的话，结果*1000就可以了
        let s
            = Math.acos(
                Math.sin(lat1) * Math.sin(lat2)
                    + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
            ) * R;
        return s;
    },
    /**
     * 墨卡托坐标到经纬度坐标的转换
     * @param {string}} merX 经度
     * @param {string}} merY 纬度
     */
    mercatorlonLat(merX, merY) {
        let band = [12890594.86, 8362377.87, 5591021, 3481989.83, 1678043.12, 0];
        // 多项式系数
        let MC2LL = [
            [
                1.410526172116255e-8,
                0.00000898305509648872,
                -1.9939833816331,
                200.9824383106796,
                -187.2403703815547,
                91.6087516669843,
                -23.38765649603339,
                2.57121317296198,
                -0.03801003308653,
                17337981.2
            ],
            [
                -7.435856389565537e-9,
                0.000008983055097726239,
                -0.78625201886289,
                96.32687599759846,
                -1.85204757529826,
                -59.36935905485877,
                47.40033549296737,
                -16.50741931063887,
                2.28786674699375,
                10260144.86
            ],
            [
                -3.030883460898826e-8,
                0.00000898305509983578,
                0.30071316287616,
                59.74293618442277,
                7.357984074871,
                -25.38371002664745,
                13.45380521110908,
                -3.29883767235584,
                0.32710905363475,
                6856817.37
            ],
            [
                -1.981981304930552e-8,
                0.000008983055099779535,
                0.03278182852591,
                40.31678527705744,
                0.65659298677277,
                -4.44255534477492,
                0.85341911805263,
                0.12923347998204,
                -0.04625736007561,
                4482777.06
            ],
            [
                3.09191371068437e-9,
                0.000008983055096812155,
                0.00006995724062,
                23.10934304144901,
                -0.00023663490511,
                -0.6321817810242,
                -0.00663494467273,
                0.03430082397953,
                -0.00466043876332,
                2555164.4
            ],
            [
                2.890871144776878e-9,
                0.000008983055095805407,
                -3.068298e-8,
                7.47137025468032,
                -0.00000353937994,
                -0.02145144861037,
                -0.00001234426596,
                0.00010322952773,
                -0.00000323890364,
                826088.5
            ]
        ];
        let params;
        for (let i = 0; i < band.length; i++) {
            if (Math.abs(merY) >= band[i]) {
                params = MC2LL[i];
                break;
            }
        }
        let lng = params[0] + params[1] * Math.abs(merX);
        let lat = Math.abs(merY) / params[9];
        lat
            = params[2]
            + params[3] * lat
            + params[4] * Math.pow(lat, 2)
            + params[5] * Math.pow(lat, 3)
            + params[6] * Math.pow(lat, 4)
            + params[7] * Math.pow(lat, 5)
            + params[8] * Math.pow(lat, 6);
        lng *= merX < 0 ? -1 : 1;
        lat *= merY < 0 ? -1 : 1;
        // 输出 '经度,纬度' 的格式，可调
        return {x: lng.toFixed(6), y: lat.toFixed(6)};
    },
    // 截取字符串
    getStr(string, str) {
        let str_before = string.split(str)[0];
        let str_after = string.split(str)[1];
        return {x: str_before, y: str_after};
    }
};

export const FirstOpenAppTools = {
    /**
     * 是否有第一次调起百度地图app的标识 false：不做处理  true：唤起百度地图app
     * @param {Object} cookieName 文件名_页面功能（可省略）_first_open 例：epidemic_first_open或者epidemic_poilistClick_first_open
     * @returns {boolean}
     */
    FirstOpenApp(cookieName) {
        // 从cookie中获取参数cookieName的值
        let val = FirstOpenAppTools.getUserCookie(cookieName);
        if (val) {
            return false;
        }
        // 不存在 储存 cookieName = BAIDUID 返回true
        const strMatch = (document.cookie + ';').match(/BAIDUID=([^;]*);/);
        if (strMatch && strMatch.length > 1) {
            FirstOpenAppTools.setUserCookie(cookieName, strMatch[1], 1);
            return true;
        }
    },
    /**
     * 设置cookie expires储存时间按天计算
     * @param {Object} name
     * @param {Object} value
     * @param {Object} expires
     * @returns {boolean}
     */
    setUserCookie(name, value, expires) {
        const date = new Date();
        date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + encodeURI(value) + ';expires=' + date.toGMTString();
    },
    /**
     * 从cookie中获取key = name 的值
     * @param {Object} name
     * @param {Object} value
     * @param {Object} expires
     * @returns {String|null}
     */
    getUserCookie(name) {
        const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        const arr = document.cookie.match(reg);
        if (arr) {
            return decodeURI(arr[2]);
        }
        return null;
    }
};

/**
 * ulink调起
 *
 * @param {Object} params ulink相关参数
 */
export function UlinkCallNa(params) {
    const {url = '', src = '', token = '', from = '', openapi = ''} = params;
    let openApi
        = openapi
        || `baidumap://map/cost_share?popRoot=no&url=${encodeURIComponent(
            url
        )}&needLocation=yes&src=${src}`;
    // unlik失败的回调地址，为蓝色下载页
    let cbkUrl = `https://map.baidu.com/zt/client/index/?down=iphone&from=${from}&token=${token}&openapi=${encodeURIComponent(
        openApi
    )}`;
    let universalUrl
        = 'https://clientmap.baidu.com/map/maplink.php?'
        + 'cburl='
        + encodeURIComponent(cbkUrl)
        + '&openapi='
        + encodeURIComponent(openApi);
    window.location.href = universalUrl;
}
/**
 * 判断壳浏览器
 *
 * @param {String} src_start src前缀
 */
export function assembleSrc(src_start) {
    let str = 'qita';
    // 用于判断对应的壳浏览器
    let userAgent = navigator.userAgent || '';
    if (/VivoBrowser/i.test(userAgent)) {
        str = 'VivoBrowser';
    }
    else if (/UCBrowser/i.test(userAgent)) {
        str = 'UCBrowser';
    }
    else if (/SamsungBrowser/i.test(userAgent)) {
        str = 'SamsungBrowser';
    }
    else if (/huawei/i.test(userAgent)) {
        str = 'HuaweiBrowser';
    }
    else if (/OppoBrowser/i.test(userAgent)) {
        str = 'OppoBrowser';
    }
    else if (/MiuiBrowser/i.test(userAgent)) {
        str = 'MiuiBrowser';
    }
    else if (/VivoBrowser/i.test(userAgent)) {
        str = 'VivoBrowser';
    }
    else if (/Sogou/i.test(userAgent)) {
        str = 'Sogou';
    }
    else if (/QQBrowser/i.test(userAgent)) {
        str = 'QQBrowser';
    }
    else if (/MZBrowser/i.test(userAgent)) {
        str = 'MZBrowser';
    }
    else if (/weibo/i.test(userAgent)) {
        str = 'weibo';
    }
    else if (/version\/([\d.]+).*safari/i.test(userAgent)) {
        str = 'safari';
    }
    else if (/CriOS/i.test(userAgent)) {
        str = 'Chrome';
    }
    else if (/baidu/i.test(userAgent)) {
        str = 'baidu';
    }
    return src_start + str;
}
/**
 * 复制到剪切板
 *
 * @param {String} text 复制的token值
 */
export function setClipBoard(text) {
    let aux = document.createElement('input');

    // 获得需要复制的内容
    aux.setAttribute('value', text);
    aux.readOnly = 'readOnly';

    // 添加到 DOM 元素中
    document.body.appendChild(aux);

    // 执行选中
    // 注意: 只有 input 和 textarea 可以执行 select() 方法.
    aux.select();
    // 兼容iOS， ios 不支持 input.select
    aux.setSelectionRange(0, aux.value.length);
    // 获得选中的内容
    let content = window.getSelection().toString();

    // 执行复制命令
    document.execCommand('copy');
    // 将 input 元素移除
    document.body.removeChild(aux);
}
/**
 * 应用宝调起
 * @param {String} from
 * @param {String} token
 * @param {String} openApi
 */
export function yingyongbaoCallUp(from, token, openApi) {
    window.location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.baidu.BaiduMap&from=${from}&token=${token}&openapi=${encodeURIComponent(
        openApi
    )}`;
}
/**
 * 普通下载页
 *
 * @param {String} from
 * @param {String} token
 * @param {String} openApi
 */
export function downPageCallUp(from, token, openApi) {
    window.location.href = `https://map.baidu.com/mapclient-pages/download/index.html?from=${from}&token=${token}&openapi=${encodeURIComponent(
        openApi
    )}`;
}
/**
 * IOS商店调起
 * @param {String} from
 * @param {String} token
 * @param {String} openApi
 */
export function IOSMarkerCallUp(from, token, openApi) {
    window.location.href = `https://itunes.apple.com/cn/app/id452186370?ls=1&mt=8&from=${from}&token=${token}&openapi=${encodeURIComponent(
        openApi
    )}`;
}
/**
* 比较两个客户端版本的大小
*
* @param {string} v1 版本1
* @param {string} v2 版本2
* @return {number} 比较结果
*/
export function compareNAVersion(v1, v2) {
    if (v1 === v2) {
        return 0;
    }

    let v1Arr = v1.split('.');
    let v2Arr = v2.split('.');

    v1Arr.map(function (item, index) {
        v1Arr[index] = parseInt(item, 10);
    });
    v2Arr.map(function (item, index) {
        v2Arr[index] = parseInt(item, 10);
    });

    for (let i = 0; i < v1Arr.length; i++) {
        if (v1Arr[i] > v2Arr[i]) {
            return 1;
        }
        else if (v1Arr[i] === v2Arr[i]) {
            continue;
        }
        else {
            return -1;
        }
    }
}

// 双端不显示返回按钮处理
// 首先跳转链接需要特殊处理:baidumap://map/cost_share?hideshare=yes&navigationStatus=2&popRoot=no&attachinfo=1&hiddenTitle=1&hiddenBackBtn=1&url=`+ encodeURIComponent(url);
// 处理后可以隐藏顶部header，分享按钮，安卓端的后退按钮，ios后退按钮需要单独处理
// ios隐藏后退按钮
export function hideBackBtn() {
    if (isBaiduMap()) {
        requestBdApi('bdapi://updatetitle', {
            backBtnColor: 'black',
            hidetitle: 1,
            hideprogress: 1,
            hiddenBackBtn: 1
        });
    }
}

/**
 * 地图内直调起其他app
 *
 *  @param {String} scheme 跳转白名单，例：小红书xhsdiscover://
 *  @param {String} fallbackUrl 直呼失败，跳转下载链接
 *  @param {Array} pvHead 埋点
 *  @param {Object} pvParam 埋点参数
 *  @param {Boolean} isAddSuccAndFail 跳转三方失败是否埋点
 *  @param {Object} failPvParam 跳转失败埋点参数
 *  @param {Function} cb 跳转成功回掉
 *  @param {Function} fallCb 跳转失败回掉
 */
export const baiduMapJumpOtherApp = jumpParam => {
    const {scheme = '', fallbackUrl = '', pvHead = [], pvParam = {},
        isAddSuccAndFail = false, failPvParam = {}, cb, fallCb
    } = jumpParam || {};
    if (!scheme) {
        return;
    }
    // 呼端调起回调
    window.callbackfunc = res => {
        const {status} = res || {};
        // 调起失败，跳转下载页面或小程序处理
        if (status !== 1 && fallbackUrl) {
            // 如果跳转失败，进行失败的埋点
            if (isAddSuccAndFail) {
                addPvNew(pvHead, failPvParam);
            }
            if (fallbackUrl.indexOf('baidumap://') >= 0) {
                window.location.href = fallbackUrl;
                return;
            }
            window.location.href = 'baidumap://map/cost_share?popRoot=no&url=' + encodeURIComponent(fallbackUrl);
            if (fallCb) {
                fallCb();
            }
            return;
        }
        addPvNew(pvHead, pvParam);
        if (cb) {
            cb();
        }
    };

    const urlParam = {scheme, launchCallback: 'callbackfunc'};
    const url = 'bdapi://growth/launch3rdApp?params=' + encodeURIComponent(JSON.stringify(urlParam));
    window.location.href = url;
};

/**
 * 参数按照 key 字典序排序并生成 query 格式
 */
export const stringifyParams = params => {
    const sortedKeys = Object.keys(params).sort();
    const paramString = sortedKeys.map(key => `${key}=${params[key]}`).join('&');
    return paramString;
};

// 创建一个单例 IntersectionObserver 对象，每种类型的观测实例对应一个类型的场景
// 例如，单篇曝光浏览分为single-show-top（笔记头部曝光观测）和single-show-end（笔记尾部结束观测）两种场景
let observerObj = {};

// 观测元素集合
const elementsMap = new Map();

const initObserver = (cb, config, type) => {
    if (!observerObj[type]) {
        const params = {
            root: null,
            ...config
        };
        observerObj[type] = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                // 如果目标元素进入视窗
                if (entry.intersectionRatio > 0) {
                    const showElement = entry.target;
                    cb && cb(entry.target);
                    // 曝光上报完成，取消观察该元素
                    observerObj[type].unobserve(showElement);
                    elementsMap.delete(showElement);
                }
            });
        }, params);
    }
};

// 元素展示曝光观测
export const domShowObserve = (dom, cb, config = {}, type = '') => {
    if (type === '') {
        return;
    }
    if (!observerObj[type]) {
        initObserver(cb, config, type);
    }
    if (dom && !elementsMap.has(dom)) {
        observerObj[type].observe(dom);
        elementsMap.set(dom, true);
    }
};

// 是否是离线打开

export function isOffline() {
    const url = window.location.href;

    if (isBaiduMap()) {
        if (isAndroid() || isAndroidCom()) {
            if (url.indexOf('https://com.baidu.baidumap.applocal.client.map.baidu.com') === 0) {
                return true;
            };
        }
        if (isIos()) {
            if (url.indexOf('file://') === 0) {
                return true;
            };
        }
    }

    return false;
}

export const isOfflinePlat = isOffline();

// 是否是微详情NA组件包
export function isNaComponent() {
    const locationParam = getUrlParams(location.href);
    const {sv = ''} = locationParam || {};
    const newVersion = compareNAVersion(sv, '20.2.50') >= 0;

    return isBaiduMap() && isOffline() && newVersion;
}

// 接口请求，bdapi代理/superagent
export function fetchData(url, {
    method = 'get',
    params,
    headers = {}
}) {
    const randomStr = genUUID().replace(/-/g, '_');
    const successCallbackName = `onSuccess_${randomStr}`;
    const failCallbackName = `onFail_${randomStr}`;

    // 新版本组件包内使用bdapi代理请求
    return new Promise((resolve, reject) => {
        if (isNaComponent()) {
            window[successCallbackName] = res => {
                try {
                    resolve(res);
                }
                finally {
                    delete window[successCallbackName];
                    delete window[failCallbackName];
                }
            };
            window[failCallbackName] = error => {
                try {
                    reject(error);
                }
                finally {
                    delete window[successCallbackName];
                    delete window[failCallbackName];
                }
            };
            const bdapiurl = Const.baseUrl + url;
            const paramString = JSON.stringify(params);
            const headersString = JSON.stringify(headers);

            requestBdApi('bdapi://proxyrequest', {
                url: bdapiurl,
                method: method,
                param: paramString,
                headers: headersString,
                success: successCallbackName,
                fail: failCallbackName
            });
        }
        else {
            const request = method === 'get' ? superAgent.get(url).query(params) : superAgent.post(url).send(params);
            request.set('Access-Control-Allow-Origin', '*');
            // 设置请求头
            if (Object.keys(headers).length > 0) {
                Object.entries(headers).forEach(([key, value]) => {
                    request.set(key, value);
                });
            }
            else {
                request.set('Content-Type', 'application/json');
            }

            request.then(res => {
                resolve(res.body);
            }).catch(error => {
                reject(error);
            });
        }
    });
}


// 获取跳转到floatweb的host信息
export function getFloatWebUrl() {
    // 非组件包，直接跳转到当前域名链接
    let hostname = Const.hostname;
    // 组件包内跳转线上蒙层
    if (isNaComponent()) {
        hostname = 'newclient.map.baidu.com';
    }
    return hostname;
}

// 特殊表情符号截取
export function specialCharacterSubstring(str, startIndex = 0, endIndex = str.length) {
    if (typeof str !== 'string') {
        return '';
    }

    let index = 0;
    let strRes = '';

    for (const char of str) {
        if (index >= startIndex) {
            strRes += char;
        }
        if (index >= endIndex - 1) {
            break;
        }
        index++;
    }

    return strRes;
}

/**
 * 字符串长度处理，最多展示8个中文字符
 */
export function truncateString(str, maxLength) {
    let length = 0;
    let truncatedString = '';

    for (let i = 0; i < str.length; i++) {
        const char = str[i];
        // 判断字符是否是数字或英文字母
        if ((char >= '0' && char <= '9') || (char >= 'a' && char <= 'z') || (char >= 'A' && char <= 'Z')) {
            length += 1;
        }
        else {
            // 汉字或表情等其他字符占用两个长度
            length += 2;
        }

        // 如果总长度大于 maxLength，截断字符串并添加省略号
        if (length >= maxLength) {
            truncatedString = str.substring(0, i) + '...';
            return truncatedString;
        }
    }
    return str;
}

// 根据坐标点，获取bound范围
export function getPointBound(x = 0, y = 0, distance = 0) {
    // 计算和字符串转换
    function calculateBound(coordinate, distance) {
        return `${Math.ceil(Number(coordinate) + distance)}`;
    }

    const x1 = calculateBound(x, -distance);
    const y1 = calculateBound(y, -distance);
    const x2 = calculateBound(x, distance);
    const y2 = calculateBound(y, distance);

    return [x1, y1, x2, y2];
}

// 是否为base64图片
export function isBase64Url(str = '') {
    // Base64URL正则表达式
    const base64UrlRegex = /data:image\/.*;base64/;
    return base64UrlRegex.test(str.replace(/[\s\n]+$/, '')); // 去除字符串末尾的空白字符
}

// 解析url中的组件包版本
export function getComVersion() {
    // 解析url中的组件包版本
    const regex = /.baidu\.commicroDetail_(\d+\.\d+\.\d+)/;
    const match = location.href.match(regex);
    if (match) {
        const version = match[1]; // 提取的版本号
        return version;
    }
    return '';
}

/**
 * 将 { a: 1, b: 2, c: [3, 4] } 转成 a=1&b=2&c=[3,4]
 * @param obj 对象
 * @param encodeValue 是否使用encodeURIComponent方法，默认为true
 * @return url
 */
function parseObjectToUrlString(obj, encodeValue = true) {
    if (objectType(obj) !== 'Object') {
        return '';
    }
    let arr = [];
    let tmp = '';
    const encode = encodeValue ? encodeURIComponent : v => v;
    const deal = v => {
        const type = objectType(v);
        if (type === 'Array' || type === 'Object') {
            return JSON.stringify(v);
        }
        return encode(v);
    };
    for (let k in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
            let v = obj[k];
            tmp = `${k}=${deal(v)}`;

            arr.push(tmp);
        }
    }
    return arr.join('&');
};

/**
 * 获取真实js数据类型
 * @param obj 输入的数据
 * @return - 数据类型 Null\Object\Promise...
 * @see => https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Data_structures
 */
export function objectType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1);
};

/**
 * 向url追加参数，处理向url添加参数?和&的问题
 * @param href - url
 * @param param - 参数
 * @return 追加后的url
 */
export function appendParam(href, param) {
    if (!param || JSON.stringify(param) === '{}') {
        return href;
    }
    if (objectType(param) === 'Object') {
        param = parseObjectToUrlString(param);
    }
    if (!href) {
        href = '';
    }
    if (href.endsWith('?')) {
        href += param;
    }
    else if (href.endsWith('&')) {
        if (href.includes('?')) {
            href += param;
        }
        else {
            href += `?${param}`;
        }
    }
    else {
        if (href.includes('?')) {
            href += `&${param}`;
        }
        else {
            href += `?${param}`;
        }
    }
    return href;
};

/**
 * 向baidumap:链接中的url添加参数
 * 例：baidumap://map/cost_share?hideshare=yes&popRoot=no&hiddenTitle=1&hiddenBackBtn=1&url=XXX
 *
 * @param url 需要添加的baidumap://链接
 * @param params 需要添加到URL中的参数对象
 * @returns 返回添加参数后的URL
 */
export function addParamsToOpenApi(url, params) {
    if (!url || url.indexOf('baidumap://') < 0 || !params || !Object.keys(params).length) {
        return url;
    }

    // 通过正则表达式提取url参数
    let urlMatch = url.match(/url=([^&]*)/);
    if (urlMatch && urlMatch[1]) {
        // 解码url参数
        let targetUrl = decodeURIComponent(urlMatch[1]);
        targetUrl = appendParam(targetUrl, params);

        // 将修改后的url重新编码
        let encodedUrl = encodeURIComponent(targetUrl);

        // 将修改后的url替换回原始链接中
        let updatedUrl = url.replace(/url=[^&]*/, `url=${encodedUrl}`);
        return updatedUrl;
    }
    return url;
}